import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { Footer } from "@/components/Footer/Footer";
import { AnimatedLoader } from "@/components/Loaders/AnimatedLoader";
import { PageLoader } from "@/components/Loaders/PageLoader";
import { WhatsAppButton } from "@/components/WhatsApp/WhatsAppButton";
import { MyBooking } from "@/features/bookings/components/MyBooking";
import { MyBookingHeader } from "@/features/bookings/components/MyBookingHeader";
import type { SearchScope } from "@/types/types";

export const Route = createFileRoute("/_authenticated/bookings_/$scope/$id")({
  params: {
    parse: (
      rawParams: Record<string, string>,
    ): { scope: SearchScope; id: string } => {
      if (!["flights", "hotels", "trips"].includes(rawParams.scope)) {
        throw new Error("Invalid scope");
      }
      return {
        scope: rawParams.scope as SearchScope,
        id: rawParams.id,
      };
    },
  },
  component: RouteComponent,
});

const iconMap = {
  flights: "airplane",
  hotels: "buildings",
  trips: "trip",
} as const;

function RouteComponent() {
  const { scope, id } = Route.useParams();

  return (
    <main className="main">
      <div className="min-h-full w-full overflow-auto">
        <Suspense
          fallback={
            <PageLoader>
              <AnimatedLoader icon={iconMap[scope]} />
            </PageLoader>
          }
        >
          <MyBookingHeader />

          <div className="px-4">
            <MyBooking scope={scope} reservationId={id} />
          </div>

          <WhatsAppButton />
        </Suspense>
      </div>

      <Footer />
    </main>
  );
}
